import { useEffect, useState } from 'react'
import { Moon, Sun } from 'lucide-react'
import { experiencia } from '../utils/api'
import { useAuth } from '../contexts/AuthContext'

export default function ThemeToggle() {
  const { user } = useAuth()
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || (matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'))
  const [preferences, setPreferences] = useState(null)

  useEffect(() => {
    if (!user) return
    experiencia.preferencias().then(({ data }) => {
      setPreferences(data)
      const synced = data.tema === 'claro' ? 'light' : data.tema === 'escuro' ? 'dark' : null
      if (synced) setTheme(synced)
    }).catch(() => {})
  }, [user])

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    document.documentElement.classList.toggle('dark', theme === 'dark')
    document.getElementById('app-theme-color')?.setAttribute('content', theme === 'light' ? '#F5F5F7' : '#000000')
    localStorage.setItem('theme', theme)
  }, [theme])

  const light = theme === 'light'

  const handleToggle = () => {
    const next = light ? 'dark' : 'light'
    const applyTheme = () => {
      setTheme(next)
      if (user && preferences) {
        const updated = { ...preferences, tema: next === 'light' ? 'claro' : 'escuro' }
        setPreferences(updated)
        experiencia.salvarPreferencias(updated).catch(() => {})
      }
    }

    if (typeof document !== 'undefined' && typeof document.startViewTransition === 'function') {
      document.startViewTransition(applyTheme)
    } else {
      applyTheme()
    }
  }

  return (
    <button
      onClick={handleToggle}
      title={light ? 'Usar modo escuro' : 'Usar modo claro'}
      aria-label={light ? 'Usar modo escuro' : 'Usar modo claro'}
      className="theme-toggle inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold active:scale-[0.96] transition-[transform,background-color,border-color,color] duration-150"
    >
      {light ? <Moon size={16} aria-hidden="true"/> : <Sun size={16} aria-hidden="true"/>}
      <span>{light ? 'Escuro' : 'Claro'}</span>
    </button>
  )
}
